export default __webpack_public_path__ + "static/media/03_photo.eecc8655.jpg";